import React from 'react';

import { StyledAvatar } from 'components/avatars';
import styled from 'styled-components';
import { StyledGrid, StyledBox, StyledTypography, FlexCSS } from 'styles/common';

import DateComp from 'uiToolkit/DateComp';

const FEEDBACK_TYPE = {
  REVIEW: 'REVIEW',
  CONTINUOUS_FEEDBACK: 'CONTINUOUS_FEEDBACK',
};

const CONTINUOUS_FEEDBACK_TYPE_TEXT = {
  PROVIDED: 'Feedback Shared',
  REQUESTED: 'Feedback Requested',
};

const ReviewRow = ({ employee, review, handleReviewAction }) => {
  const handleClick = () => {
    handleReviewAction({
      reviewId: review.id,
      employeeId: review.receiverEmployeeId,
      submissionStatus: review.submissionStatus,
      reviewProviderType: review.providerType,
      reviewStage: review.feedbackForm?.currentStage,
      isReview: review.responseType === FEEDBACK_TYPE.REVIEW,
      feedbackType: review.feedbackType,
      feedbackId: review.feedbackForm?.id,
      providerEmployeeId: review.providerEmployeeId,
      isPublished: review.isPublished,
    });
  };

  return (
    <RowContainer onClick={handleClick}>
      <StyledGrid container>
        <StyledGrid item xs={3}>
          <StyledBox flexcontainer justifycontent="flex-start" alignitems="center">
            <StyledAvatar size="smallMedium" src={employee.profilePhotoSrc} />
          </StyledBox>
        </StyledGrid>
        <StyledFlexGrid item xs={9} flexcontainer alignitems="stretch">
          <StyledGrid container>
            <StyledGrid item xs={12}>
              <StyledTypography weight="500">{employee.displayName}</StyledTypography>
            </StyledGrid>
            <StyledGrid item xs={9}>
              <FullHeightBox flexcontainer justifycontent="center" alignitems="flex-start" flexdirection="column">
                {review.responseType === FEEDBACK_TYPE.REVIEW && (
                  <StyledTypography rightGutter={0.5} variant="body2" color="textSecondary">
                    {review.feedbackForm.reviewCycle.name}
                  </StyledTypography>
                )}
                {review.responseType === FEEDBACK_TYPE.CONTINUOUS_FEEDBACK && (
                  <StyledTypography variant="body2" color="textSecondary">
                    Continuous Feedback
                  </StyledTypography>
                )}
              </FullHeightBox>
            </StyledGrid>
            <StyledGrid item xs={3}>
              <FullHeightBox flexcontainer justifycontent="center" alignitems="flex-end">
                {review.submissionDateFormatted && (
                  <DateComp
                    color={review.submissionDateFormatted?.color}
                    startDateTime={review.submissionDateFormatted?.timeStamp}
                    isCrossed={review.submissionDateFormatted?.isCrossed}
                    editable={false}
                    tooltip={review.submissionDateFormatted?.reason}
                  />
                )}
              </FullHeightBox>
            </StyledGrid>
          </StyledGrid>
        </StyledFlexGrid>
      </StyledGrid>
    </RowContainer>
  );
};

export default ReviewRow;

const FullHeightBox = styled(StyledBox)`
  height: 100%;
`;

const RowContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 24px;
  position: relative;
  border-bottom: 1px solid ${(props) => props.theme.palette.divider};
  box-sizing: border-box;
  cursor: pointer;
  &:hover {
    box-shadow:
      0 1px 2px 0 ${(props) => props.theme.palette.shadows.card},
      0 2px 6px 2px ${(props) => props.theme.palette.shadows.card};
    background-color: ${(props) => props.theme.palette.background.blue.light.v2};
  }
  transition: all 0.2s;
`;

const StyledFlexGrid = styled(StyledGrid)`
  ${FlexCSS}
`;
